interface MenuItem {
  name: string;
  url?: string;
  external?: boolean;
  menuLinks?: MenuItem[];
}

export const skipLinks: Array<{ name: string; url: string }> = [
  {
    name: 'Skip to main content',
    url: '#main',
  },
  {
    name: 'Skip to footer',
    url: '#footer',
  },
];

export const getTopLinksWithMenu = (baseUrl?: string): MenuItem[] => {
  const links = [
    {
      name: 'Ways to shop',
      menuLinks: [
        {
          name: 'Services and experiences',
          url: '/our-services',
        },
        {
          name: 'Gift cards',
          url: '/customer-services/prices-and-payment/gift-cards',
        },
        {
          name: 'Our app',
          url: '/customer-services/shopping-with-us/our-apps',
        },
        {
          name: 'Brands A-Z',
          url: '/brands',
        },
        {
          name: 'John Lewis for Business',
          url: '/business',
        },
      ],
    },
    {
      name: 'Help',
      menuLinks: [
        {
          name: 'Customer services',
          url: '/customer-services',
        },
        {
          name: 'Track your order',
          url: `${baseUrl || ''}/track-order`,
        },
        {
          name: 'Returns and refunds',
          url: '/customer-services/returns',
        },
        {
          name: 'Delivery and collection',
          url: '/customer-services/delivery-information',
        },
        {
          name: 'Product support',
          url: 'https://productsupport.johnlewis.com',
        },
        {
          name: 'Contact us',
          url: '/customer-services/contact-us',
        },
      ],
    },
    {
      name: 'John Lewis Money',
      menuLinks: [
        {
          name: 'Partnership Credit Card',
          url: 'https://www.johnlewismoney.com/partnership-credit-card?sourcecode=3521500AAJLPDOM20100&utm_medium=referral&utm_source=johnlewis.co.uk&utm_campaign=JLPreNavApr26-&track=jli:JLPreNav-JLPC0441_NA_Apr26',
          external: true,
        },
        {
          name: 'Home Insurance',
          url: 'https://www.johnlewismoney.com/home-insurance?utm_medium=referral&utm_source=johnlewis.co.uk&utm_campaign=banner&track=jli:JLFSJLM_NA_0725',
          external: true,
        },
        {
          name: 'Car Insurance',
          url: 'https://www.johnlewismoney.com/insurance/car-insurance.html?utm_medium=referral&utm_source=johnlewis.co.uk&utm_campaign=banner&track=jli:JLFSJLM_NA_0725',
          external: true,
        },
        {
          name: 'Pet Insurance',
          url: 'https://www.johnlewismoney.com/pet-insurance?utm_medium=referral&utm_source=johnlewis.co.uk&utm_campaign=banner&track=jli:JLFSJLM_NA_0725',
          external: true,
        },
        {
          name: 'Travel Money',
          url: 'https://www.johnlewismoney.com/travel-money?utm_medium=referral&utm_source=johnlewis.co.uk&utm_campaign=banner&track=jli:JLFSJLM_NA_0725',
          external: true,
        },
        {
          name: 'International Payments',
          url: 'https://www.johnlewismoney.com/international-payments?track=xc55',
          external: true,
        },
        {
          name: 'Loans',
          url: 'https://www.johnlewismoney.com/personal-loans?utm_medium=referral&utm_source=johnlewis.co.uk&utm_campaign=banner&track=jli:JLFSJLM_NA_0725',
          external: true,
        },
        {
          name: 'Payment Plans',
          url: 'https://www.johnlewis.com/our-services/paymentplans?utm_medium=referral&utm_source=johnlewis.co.uk&utm_campaign=banner&track=jli:JLFSJLM_NA_0725',
          external: true,
        },
      ],
    },
    {
      name: 'My John Lewis',
      url: '/our-services/my-john-lewis',
    },
    {
      name: 'Our stores',
      url: '/our-shops',
      menuLinks: [],
    },
  ];

  return links;
};

export const getAccountLinks = (baseUrl?: string, myAccountUrl?: string) => [
  {
    name: 'My account',
    url: myAccountUrl || '/my-account',
  },
  {
    name: 'Online orders',
    url: `${baseUrl || ''}/orders`,
  },
  {
    name: 'My John Lewis rewards',
    url: `${baseUrl || ''}/rewards`,
  },
  {
    name: 'My reviews',
    url: `${baseUrl || ''}/my-reviews`,
  },
  {
    name: 'Wish list',
    url: `${baseUrl || ''}/wish-list`,
  },
  {
    name: 'Appointments',
    url: '/appointments/manage',
  },
  {
    name: 'Sign out',
    url: '/sign-out',
  },
];

export const FEEDBACK_LINK =
  'https://edigitalsurvey.com/survey/enter/s/ESV-136225211/data2/mobile/collection_url/';
